module.exports = "pegasus_template/assets/themecapture1/health/104.png";